import { deduplicateEntities } from "../utils/entityUtils";

export interface PaymentCustomerOption {
  id: number;
  name: string;
  user_type: string;
  email?: string;
  phone?: string;
  warehouse_id?: number;
}

export interface PaymentSupplierOption {
  ID_Frs: number;
  Nom_Raison_Sociale: string;
  USER_ID: number;
}

export function buildPaymentCustomerOptions(
  rawCustomers: unknown,
  warehouseId?: number | null
): PaymentCustomerOption[] {
  if (!Array.isArray(rawCustomers)) return [];

  const formattedCustomers = rawCustomers
    .map((customer: any): PaymentCustomerOption | null => {
      const id = Number(customer?.id);
      if (!Number.isFinite(id)) return null;

      const rawWarehouseId =
        customer?.warehouse_id ?? customer?.detail_warehouse_id;
      const normalizedWarehouseId = Number(rawWarehouseId);

      return {
        id,
        name: customer?.name || "Client sans nom",
        user_type: customer?.user_type,
        email: customer?.email,
        phone: customer?.phone,
        warehouse_id: Number.isFinite(normalizedWarehouseId)
          ? normalizedWarehouseId
          : undefined,
      };
    })
    .filter(
      (customer): customer is PaymentCustomerOption => customer !== null
    );

  const normalizedScope = Number(warehouseId);
  const scopedCustomers = Number.isFinite(normalizedScope)
    ? formattedCustomers.filter(
        (customer) => customer.warehouse_id === normalizedScope
      )
    : formattedCustomers;

  return deduplicateEntities(scopedCustomers);
}

export function buildPaymentSupplierOptions(
  rawSuppliers: unknown
): PaymentSupplierOption[] {
  if (!Array.isArray(rawSuppliers)) return [];

  const normalizedSuppliers = rawSuppliers
    .map((supplier: any) => {
      const id = Number(supplier?.id ?? supplier?.ID_Frs);
      const userId = Number(supplier?.user_id ?? supplier?.USER_ID ?? id);
      if (!Number.isFinite(id) || !Number.isFinite(userId)) return null;

      return {
        id,
        ID_Frs: id,
        Nom_Raison_Sociale:
          supplier?.name ||
          supplier?.company_name ||
          supplier?.Nom_Raison_Sociale ||
          "Sans nom",
        USER_ID: userId,
      };
    })
    .filter(
      (
        supplier
      ): supplier is PaymentSupplierOption & { id: number } =>
        supplier !== null
    );

  return deduplicateEntities(normalizedSuppliers).map(({ id: _id, ...supplier }) =>
    supplier
  );
}
